export default {
    mounted(el) {
        let isDown = false;
        let startX;
        let startY;
        let scrollLeft;
        let scrollTop;

        const mouseDownHandler = (e) => {
            if (e.target.closest('.sort-button')) {
                // Клик на кнопке сортировки → drag-scroll НЕ активируется
                return;
            }

            if (e.target.closest('.range-body')) {
                // Клик на ползунку НЕ активирутся
                return;
            }

            if (e.target.closest('.range')) {
                // Клик на range НЕ активирутся
                return;
            }
            
            const tag = e.target.tagName.toLowerCase();

            // Не реагировать на интерактивные элементы
            if (['input', 'textarea', 'button', 'select'].includes(tag) || e.target.isContentEditable) {
                if (!e.target.disabled) {
                    return;
                }
            }

            if (['select-field', 'autocomplete-field'].some(item => {
                const el = e.target.closest('.' +item);
                
                return el && !el.classList.contains('disabled');  
            })) {
                return;
            }

            isDown = true;
            el.classList.add('dragging');
            startX = e.pageX;
            startY = e.pageY;
            scrollLeft = el.scrollLeft;
            scrollTop = el.scrollTop;
            // e.preventDefault();

            window.addEventListener('mousemove', mouseMoveHandler);
            window.addEventListener('mouseup', mouseUpHandler);
        };

        const mouseMoveHandler = (e) => {
            if (!isDown) {
                return;
            }

            e.preventDefault();
            const x = e.pageX;
            const y = e.pageY;
            const walkX = (x - startX) * -1;
            const walkY = (y - startY) * -1;
            el.scrollLeft = scrollLeft + walkX;
            el.scrollTop = scrollTop + walkY;
        };

        const mouseUpHandler = () => {
            isDown = false;
            el.classList.remove('dragging');
            window.removeEventListener('mousemove', mouseMoveHandler);
            window.removeEventListener('mouseup', mouseUpHandler);
        };

        el.addEventListener('mousedown', mouseDownHandler);

        // Сохраняем обработчик для удаления
        el._dragToScroll = { mouseDownHandler };
    },
    unmounted(el) {
        const { mouseDownHandler } = el._dragToScroll;
        el.removeEventListener('mousedown', mouseDownHandler);
    }
};
